module.exports = __webpack_public_path__ + "img/L.b6baf5d9.png";